import { twMerge } from 'tailwind-merge'
import Spinner from '../Spinner'
import classnames from 'classnames'

interface ButtonProps {
	type?: 'button' | 'submit' | 'reset'
	children: React.ReactNode
	className?: string
	isLoading?: boolean
	disabled?: boolean
	onClick?: () => void
}

export default function Button({
	children,
	type = 'button',
	className,
	isLoading,
	disabled,
	onClick,
	...props
}: ButtonProps) {
	return (
		<button
			{...props}
			onClick={onClick}
			type={type}
			disabled={disabled}
			className={twMerge(
				classnames(
					'border w-full overflow-hidden border-none outline-none rounded-lg flex h-[44px] p-3 bg-brand-primary hover:bg-brand-primary/80 text-brand-text-primary stroke-white text-base justify-center items-center relative transition-all ease-linear duration-100 px-3 font-bold disabled:bg-details-outline disabled:pointer-events-none disabled:opacity-50',
					className
				)
			)}
		>
			<Spinner
				className={twMerge(
					'h-6 w-6 mr-0 hidden',
					classnames({ flex: isLoading })
				)}
			/>
			<div
				className={twMerge(
					'btn-content justify-center items-center transition-opacity flex',
					classnames({ hidden: isLoading })
				)}
			>
				{children}
			</div>
		</button>
	)
}
